<template>
  <div class="stepper">
    <button @click="decrement">−</button>
    <input type="number" min="0" v-bind:value="value" v-bind:class="color"
      v-on:input="$emit('input', $event.target.value)">
    <button @click="increment">+</button>
  </div>
</template>

<script>
import {format} from 'd3'
// import debounce from 'debounce'

export default {
  name: 'stepper',
  props: {
    value: Number,
    stepSize: Number,
    color: {
      type: String,
      default: 'black'
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    format (number) {
      if (number == 0) { return '0'}
      return format(",.3r")(number).replace(',','.')
    },
    increment () {
      this.$emit('input', this.value+this.stepSize)
    },
    decrement () {
      if (this.value > 0) {
        this.$emit('input', this.value-this.stepSize)
      }      
    },
  },
  mounted () {
  },
  updated () {
  },
  computed: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.stepper {
  display: flex;

  button {
    border: none;
    margin: 0;
    width: 40px;
    height: 40px;
    background-color: #fff;
    border-radius: 4px 0 0 4px;
    font-size: 24px;
    line-height: 1;
    border: 1px solid #fff;
    text-align: center;
    color: #666;

    &:last-of-type {
      border-radius: 0 4px 4px 0;
    }

    &:hover, &:focus, &:active {
      color: #c60000;
      cursor: pointer;
      border-color: #ddd;
    }
    
  }
  input {
    flex-grow: 1;
    border: none;
    height: 40px;
    border-radius: 0;
    margin: 0 2px;
    padding: 0 10px;
    font-family: 'FAZ Gold', Helvetica, Arial, sans-serif;
    font-size: 16px;
    overflow: hidden;
    border: 1px solid #fff;
    box-sizing: border-box;
    -webkit-appearance: none;

    &.red {
      color: #c60000;
    }

    &:hover, &:focus, &:active {
      border-color: #ddd;
    }
  }
}
</style>
